import Interceptor from '../../core/type/operation/Interceptor';
import {
  strategyOptions, starsOptions, projectTypeOptions, slaOptions,
  productProjectOptions, launchOptions, numberEmployeeSuggestions, numberAdSuggestions,
  projectDeadlineSuggestions, segmentOptions, clientTypeOptions, numberAllEmployeeSuggestions, rolesOptions,
} from './options';

const getUrlParams = (url) => {
  const params = {};
  const parser = document.createElement('a');
  parser.href = url;
  const query = parser.search.substring(1);
  const vars = query.split('&');
  for (let i = 0; i < vars.length; i += 1) {
    const pair = vars[i].split('=');
    params[pair[0]] = decodeURIComponent(pair[1]);
  }
  return params;
};

export default [

  new Interceptor(async (data) => new Promise((resolve) => {
    const params = getUrlParams(window.location.href);
    const options = {
      option_alternatives: strategyOptions,
      option_roles: rolesOptions,
      option_stars: starsOptions,
      option_project_type: projectTypeOptions,
      option_sla: slaOptions,
      option_product_project: productProjectOptions,
      option_launch: launchOptions,
      project_deadline_suggestions: projectDeadlineSuggestions,
      number_employee_suggestions: numberEmployeeSuggestions,
      number_all_employee_suggestions: numberAllEmployeeSuggestions,
      number_ad_suggestions: numberAdSuggestions,
      segment_options: segmentOptions,
      client_type_options: clientTypeOptions,
    };
    resolve({
      ...data,
      options,
      type: params.enterprise ? 'ENTERPRISE' : 'COMPANY',
      utm_source: params.utm_source,
      utm_medium: params.utm_medium,
      utm_campaign: params.utm_campaign,
    });
  })),
];
